
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store, { StoreAssignments, StoreClipboard } from "@/store";
import { LivingAppsAssignmentRecord, LivingAppsAssignmentControl } from "@/types";
import ReportsForm from "@/components/ReportsForm.vue";
import AssignmentDetailNav from "@/components/AssignmentDetailNav.vue";
import ActiveAssignmentButton from "@/components/ActiveAssignmentButton.vue";
import ClipboardButton from "@/components/ClipboardButton.vue";
import NoListEntriesMessage from "@/components/NoListEntriesMessage.vue";
import { EventBus } from "@/main";

@Component({
  components: {
    ReportsForm,
    AssignmentDetailNav,
    ActiveAssignmentButton,
    NoListEntriesMessage,
    ClipboardButton,
  },
})
export default class Reports extends Vue {
  public storeAssignments = StoreAssignments;
  public record?: LivingAppsAssignmentRecord | null = null;
  public controls?: LivingAppsAssignmentControl | null;
  public edit: boolean = false;
  public type: string = "maintenance";

  public recAudio: boolean = false;

  public get detailNavRoutes() {
    const id: string = this.$route.params.id;
    const type: string = this.type;
    return {
      infos: { name: `${this.type}_detail`, params: { id, type } },
      reports: { name: "reports", params: { id, type } },
      consumptions: { name: "consumptions", params: { id, type } },
      employees: { name: "employees", params: { id, type } },
      edit: { name: "", params: { id, type } },
    };
  }

  public get assiRecord(): LivingAppsAssignmentRecord | null | undefined {
    return this.record;
  }

  public set assiRecord(val: LivingAppsAssignmentRecord | null | undefined) {
    this.record = val;
  }

  public get records(): LivingAppsAssignmentRecord[] {
    const realRecords: LivingAppsAssignmentRecord[] = [];
    const records: LivingAppsAssignmentRecord[] = this.storeAssignments.getRecords;
    const assignmentRecord = this.getAssignmentRecord(records);
    if (assignmentRecord) {
      this.assiRecord = assignmentRecord;
      const assignmentId = assignmentRecord.auftrag_id ? assignmentRecord.auftrag_id.value : null;
      if (assignmentId) {
        for (const record of records) {
          const reportId: any = record.auftrag_id ? record.auftrag_id.value : null;
          if (record.typ && record.typ.value[0].key === "bericht" && assignmentId === reportId) {
            realRecords.push(record);
          }
        }
      }
    }
    return realRecords;
  }

  public getAssignmentRecord(records: LivingAppsAssignmentRecord[]): LivingAppsAssignmentRecord | null {
    const recordId: string = this.$route.params.id;
    for (const record of records) {
      if (record.id === recordId) {
        return record;
      }
    }
    return null;
  }

  public handleControls() {
    this.controls = this.storeAssignments.getControls;
  }

  public handleClick(route: string) {
    this.$router.push(route);
  }

  public newRecord() {
    this.edit = true;
  }

  public formFinish() {
    const refForm: any = this.$refs.reportsFormComp;
    if (refForm.isDirty) {
      EventBus.$emit("dirtyForm", this, refForm);
    } else {
      this.edit = false;
    }
  }

  public formCancel() {
    const refForm: any = this.$refs.reportsFormComp;
    this.edit = false;
    refForm.isDirty = false;
    StoreClipboard.resetAssignedQueue();
  }

  public formSaved() {
    const refForm: any = this.$refs.reportsFormComp;
    this.edit = false;
    refForm.isDirty = false;
    refForm.handleClipboardCleanup();
  }

  public deleteCancel(recordId: string) {
    const elm = document.getElementById("record-list") as HTMLIonListElement;
    if (elm) {
      elm.closeSlidingItems();
    }
  }

  public async deleteItem(recordId: string) {
    const elm = document.getElementById("record-list") as HTMLIonListElement;
    if (elm) {
      elm.closeSlidingItems();
    }
    await store.dispatch("storeAssignments/deleteRecordData", {
      recordIds: [recordId],
      app: this,
      eventBus: EventBus,
    });
  }

  public deleteAction(recordId: string) {
    EventBus.$emit("deleteListItem", this, recordId);
  }

  public handleRecordStarted() {
    this.recAudio = true;
  }

  public handleRecordCompleted() {
    this.recAudio = false;
  }

  protected mounted() {
    this.handleControls();
    this.type = this.$route.params.type;
    if (this.$route.params.edit) {
      this.edit = true;
    }
  }
}
